import { common as enCommon } from './en/common';
import { common as arCommon } from './ar/common';

const resources = {
  en: {
    common: enCommon,
  },
  ar: {
    common: arCommon,
  },
};

export default resources;
